import { asyncLoader } from './core/AsyncLoader'
import { scrollListener } from './core/ScrollListener'
import { categoryListener } from './core/CategoryListener'
import { websiteService } from './service/WebsiteService'
import { postWrapper } from './wrapper/PostWrapper'
import { loaderComponent } from './components/LoaderComponent'

window.addEventListener('DOMContentLoaded', async () => {
	const NUMBER_OF_LOAD_POSTS_PER_QUERY = 6
	const GROUP_AND_WRAP_POST_PER = false
	const postsContainer = document.querySelector('#product-post-container')
	const loaderContainer = document.querySelector('#product-loader-container')
	const metaActivCategory = document.querySelector('[data-blog-activ-categroy]')
	let activCategory = ''
	if (metaActivCategory.dataset) {
		activCategory = metaActivCategory.dataset.blogActivCategroy
	}

	if (window.location.hash) {
		let hash = window.location.href.split('#').pop()

		let active = document.querySelector('[data-categoryname="' + hash + '"]')

		if (active) {
			const options = document.querySelectorAll('.product-category')
			options.forEach(options => options.classList.remove('active'))
			activCategory = active.dataset.category
			active.classList.add('active')
		}
	}

	const metaBaseUrl = document.querySelector('[data-base-url]')
	const baseUrl = metaBaseUrl.dataset.baseUrl

	scrollListener.setContainer(postsContainer)
	loaderComponent.setContainer(loaderContainer)
	categoryListener.setContainer(document.querySelector('#products-filter-wrapper'))

	postWrapper
		.setContainer(postsContainer)
		.setPostsPerGroup(GROUP_AND_WRAP_POST_PER)

	websiteService
		.setBaseUrl(baseUrl)
		.setCounter(NUMBER_OF_LOAD_POSTS_PER_QUERY)

	await asyncLoader
		.setActiveCategoryId(activCategory)
		.setWebsiteService(websiteService)
		.loadMorePosts()

	scrollListener.addListener()
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_products_loader/script.js